export default () => ({
  Pagination: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px 0',
  },
  pageSizeControl: {
    display: 'flex',
    alignItems: 'center',
  },
  pageControl: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20,
  },
  pageNumber: {
    display: 'flex',
    alignItems: 'center',
  },
});

